import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-synapse',
  templateUrl: './synapse.component.html',
  styleUrls: ['./synapse.component.scss']
})
export class SynapseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
